// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_Hru","cls2":"ExportFormatModal-cls2_AFS ExportFormatModal-cls1_Hru"};